import { render, staticRenderFns } from "./SelectPhotosDialog.vue?vue&type=template&id=0fb63d21&"
import script from "./SelectPhotosDialog.vue?vue&type=script&lang=js&"
export * from "./SelectPhotosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports